exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mappesalvaincorso{background-color:#ff0}.mappesalvasuccesso{background-color:green}.mappesalvaerrore{background-color:maroon}", ""]);

// exports
